import { NgModule } from '@angular/core';
import { MatButtonModule, MatDialogModule, MatIconModule } from '@angular/material';
import { CommonModule } from '@angular/common';
import { WarehouseDocumentPreviewDialogComponent } from './warehouse-document-preview-dialog.component';

@NgModule({
    declarations: [
        WarehouseDocumentPreviewDialogComponent
    ],
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        CommonModule
    ],
    entryComponents: [
        WarehouseDocumentPreviewDialogComponent
    ],
})
export class WarehouseDocumentPreviewDialogModule {
}
